var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('header-block'),_c('router-view',{staticStyle:{"min-height":"550px"}}),_c('footer-block'),_c('notifications',{staticClass:"notify",attrs:{"position":"top center","group":"notify"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }